module.exports = __webpack_public_path__ + "12d61f32ef8aee0a8c9ec367050816d2.jpg";